import { render, staticRenderFns } from "./HRQueriesList.vue?vue&type=template&id=46433df4&"
import script from "./HRQueriesList.vue?vue&type=script&lang=js&"
export * from "./HRQueriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports